import React from "react";
import styled from "styled-components";
import { Button } from "antd";

const QuickActionButton = ({
  children,
  type = "primary",
  size = "large",
  block = false,
  icon,
  onClick,
  ...props
}) => {
  return (
    <StyledQuickActionButton
      type={type}
      size={size}
      block={block}
      icon={icon}
      onClick={onClick}
      {...props}
    >
      {children}
    </StyledQuickActionButton>
  );
};

const StyledQuickActionButton = styled(Button)`
  height: 48px !important;
  font-family: var(--font-primary) !important;
  font-weight: 600 !important;
  font-size: 1rem !important;
  border-radius: 12px !important;
  background: var(--gradient-primary) !important;
  border: none !important;
  box-shadow: 0 4px 16px rgba(44, 95, 45, 0.2) !important;
  margin-bottom: 1rem !important;
  min-width: 200px !important;
  color: white !important;

  @media (max-width: 768px) {
    height: 52px !important;
    font-size: 1.05rem !important;
    width: 100% !important;
    min-width: unset !important;
    padding: 0 1.5rem !important;
    box-sizing: border-box !important;
    margin-bottom: 0.5rem !important;
  }

  &:hover:not(:disabled):not(.ant-btn-loading),
  &:focus:not(:disabled):not(.ant-btn-loading),
  &:active:not(:disabled):not(.ant-btn-loading) {
    background: var(--gradient-primary) !important;
    border: none !important;
    color: white !important;
    transform: translateY(-2px) !important;
    box-shadow: 0 8px 24px rgba(44, 95, 45, 0.3) !important;
  }

  &.ant-btn-loading,
  &:disabled {
    cursor: not-allowed !important;
    opacity: 0.8 !important;
  }

  span {
    filter: brightness(0) invert(1);
    color: white !important;
  }

  .anticon {
    color: white !important;
  }
`;

export default QuickActionButton;
